<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper" v-if="!choose">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6" :sm="24">
                <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入名称查询" v-model="queryParam.templateName"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div style="display: flex;flex-direction: row;margin-bottom: 10px">
          <a-button @click="handleAdd" type="primary" icon="plus" v-if="!choose">自定义模板</a-button>
          <!--          <div style="display: flex;flex-direction: row;flex-grow: 1;padding-left: 20px">-->
          <!--            <div style="line-height: 30px;">快速创建：</div>-->
          <!--            <li v-for="(item, index) in templateList" :key="index">-->
          <!--              <a-button @click="toTemplatePage(item.uuid,item.height,item.width,item.name,1)">{{item.name}}</a-button>-->
          <!--            </li>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <a-dropdown trigger="click" :visible="dropdownVisible" @visibleChange="handleVisibleChange"  >-->
          <!--              <a-button>下载打印插件<a-icon type="down" />  </a-button>-->
          <!--              <a-menu slot="overlay" style="padding: 10px" >-->
          <!--                <a-radio-group v-model="radioValue">-->
          <!--                  <a-menu-item @click.native="showTypeModal('1')" >-->
          <!--                    <a class="commonContent_menu_item" style="cursor: pointer">-->
          <!--                      win_x64-->
          <!--                    </a>-->
          <!--                  </a-menu-item>-->
          <!--                  <a-menu-item @click.native="showTypeModal('2')" >-->
          <!--                    <a class="commonContent_menu_item" style="cursor: pointer">-->
          <!--                      win_x32-->
          <!--                    </a>-->
          <!--                  </a-menu-item>-->
          <!--                </a-radio-group>-->
          <!--              </a-menu>-->
          <!--            </a-dropdown>-->
          <!--          </div>-->
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :scroll="{ x: 500 }"
                   :pagination="ipagination" :loading="loading" @change="handleTableChange"
                   :rowSelection="choose?{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}:null"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record,2)" v-if="!choose">模板编辑</a>
              <a-divider type="vertical" v-if="!choose"/>
              <a @click="looklook(record)">预览</a>
              <a-divider type="vertical" v-if="!choose"/>
<!--              <a @click="handleEditTitle(record)">信息编辑</a>-->
<!--              <a-divider type="vertical" />-->
              <a @click="copyTemplate(record)" v-if="!choose">复制模板</a>
              <a-divider type="vertical" v-if="!choose"/>
              <a @click="delConfirm(handleDelete,record.id)" v-if="!choose">删除</a>
            </span>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <addLabeltemplate ref="modalForm" @close="modalFormClose"></addLabeltemplate>
      </a-card>
    </a-col>
    <realTimeView
      :datas="realTimeViewData"
      :val="rtv"
      ref="previewH5Template"
    />
    <!-- 编辑模版 -->
    <a-modal
      title="编辑模板"
      :visible="editModalVisible"
      @ok="handleOk"
      @cancel="handleCancel"
      width="100%"
      :footer="null"
    >
      <iframe
        :src="iframeSrc"
        width="100%"
        height="600px"
        frameborder="0"
      ></iframe>
    </a-modal>
  </a-row>
</template>
<script>
import { UDIListMixin } from './mixins/UDIListMixin'
import { addTemplate, templateDetial, delTemplate2, getPublicTemplates } from '@/api/api'
import addLabeltemplate from './modules/addLabeltemplate'
import realTimeView from './modules/realTimeView'
import Vue from 'vue'
import { ACCESS_TOKEN, PRINT_WEB_URL } from '@/store/mutation-types'

export default {
  name: 'VendorList',
  mixins: [UDIListMixin],
  components: {
    addLabeltemplate,
    realTimeView
  },
  props:{
    choose: {
      type: Boolean,
      default: false
    },
    item:{
      default: Object
    }
  },
  data () {
    return {
      rtv:{},
      realTimeViewData:false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      dropdownVisible: false,
      options: [],
      templateList: [],
      templateDetail: [],
      // 查询条件
      queryParam: {},
      editModalVisible: false,
      iframeSrc: '',
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200']
      },
      // 表头
      columns: [
        { title: '模版名称', dataIndex: 'templateName', align: 'left' },
        // { title: '备注', dataIndex: 'remark', align: 'left' },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/htmlTemplate/list',
        delete: '/supplier/delete',
        deleteBatch: '/supplier/deleteBatch',
        importExcelUrl: '/supplier/importVendor',
        exportXlsUrl: '/supplier/exportExcel',
        batchSetStatusUrl: '/supplier/batchSetStatus'
      }
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    }
  },
  created () {

  },
  methods: {
    open(){

      this.getTempInfo()
      console.log('-11-->>',this.choose,this.item)
      if(this.choose){
        //choose 是在编码规则里选择
        if(this.item.htmlTemplateId != null){
          this.selectedRowKeys = [this.item.htmlTemplateId]

        }else{
          this.selectedRowKeys = []
        }
        this.item.selectedRowKeys = this.selectedRowKeys
      }
    },
    mySelectChange(){
      this.item.selectionRows = this.selectionRows
      this.item.selectedRowKeys = this.selectedRowKeys
    },
    handleEdit: function(record, diff) {
      // 根据 record 或其他参数生成外部页面的 URL
      // const externalUrl = `http://192.168.124.13:8080/template/?id=${record.id}&token=${Vue.ls.get(ACCESS_TOKEN)}`;
      // this.iframeSrc = externalUrl
      // this.editModalVisible = true
      this.$router.push(`/system/customTemplate?id=${record.id}&token=${Vue.ls.get(ACCESS_TOKEN)}`)
    },
    looklook(record){
      templateDetial({id:record.id}).then(res=>{
        this.rtv = {
          id:res.result.id,
          name: res.result.templateJson.name,
          templateJson: JSON.stringify(res.result.templateJson),
          component: JSON.stringify(res.result.component),
        }
        console.log(this.rtv)
        this.$refs.previewH5Template.show()
        // setTimeout(()=>{
        //   this.$refs.r.show()
        // })
      })
    },
    // handleTableChange(){
    //   console.log('handleTableChange122')
    // },
    //获取公共模板信息
    async getTempInfo () {
      const res = await getPublicTemplates()
      console.log(res.data, 'getTempInfo--res')
      const datas = res.data
      console.log(res.data, 'res.data')
      this.templateDetail = res.data
      const templateLists = []
      res.data.forEach(function(item, index, array) {
        // item数组中的当前项, index当前项的索引, array原始数组；
        templateLists.push({
          name: item.templateName,
          uuid: item.uuid,
          height: item.paperHeight,
          width: item.paperWidth
        })
        console.log(templateLists, '=========templateLists============')
      })
      this.templateList = templateLists
    },
    changetime (createTime) {
      return createTime.replace('T', ' ')
    },
    //跳转显示对应模板信息
    toTemplatePage (uuid, height, width, name, diff) {
      console.log(this.templateList)
      console.log(PRINT_WEB_URL + 'edit')
      const token = Vue.ls.get(ACCESS_TOKEN)
      const templateInfo = JSON.stringify(this.templateDetail)
      // console.log(templateInfo)
      window.open(
        `http://` + PRINT_WEB_URL + `/?options=${encodeURIComponent(uuid)}&token=${encodeURIComponent(token)}&diff=${encodeURIComponent(diff)}&height=${encodeURIComponent(height)}&width=${encodeURIComponent(width)}&name=${encodeURIComponent(name)}`
      )
    },
    // handleVisibleChange (visible) {
    //   this.dropdownVisible = visible
    // },
    // 下载打印插件
    showTypeModal (e) {
      if (e == 1) {
        location.href = 'https://www.fangzhima.com/download/print64.exe'
        this.dropdownVisible = false
      } else {
        location.href = 'https://www.fangzhima.com/download/print32.exe'
        this.dropdownVisible = false
      }
    },
    printUpload () {
      location.href = 'https://www.fangzhima.com/download/print64.exe'
    },
    // 删除
    async handleDelete (templateId) {
      const res = await delTemplate2({
        id:templateId,
        status:3
      })
      console.log(res, 'res')
      if (res.code == 200) {
        this.$message.success('删除成功')
        // this.loadData(1)
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },
    searchReset () {
      this.queryParam = {}
      // this.loadData(1)
    },
    handleOk(){

    },
    handleCancel(){

    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/vendor_template.xls'
      let templateName = '供应商Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '供应商导入'
    },
    handleAdd () {
      this.$router.push(`/system/customTemplate?id=none&token=${Vue.ls.get(ACCESS_TOKEN)}`)
    },

    handleEditTitle (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '信息编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    async copyTemplate (record) {

      const that = this
      console.log('复制模板', record, record.datas[0])

      const templateOption = []
      const templateOptions = []
      for (var i = 0; i < record.datas.length; i++) {
        templateOptions.push(record.datas[i].option)
      }
      // 触发表单验证
      let params = {
        templateId: record.uuid,
        templateName: record.templateName + '_复制',
        remark: record.remark,
        options: templateOptions,
        paperHeight: record.paperHeight,
        paperWidth: record.paperWidth
      }
      //需要获取模板信息，将控件值取出放进options里options：['','']
      const res = await addTemplate(params) //改成新增模板接口addTemplate
      console.log(res, 'res')
      if (res.code == 200) {

        this.$message.success('复制成功')
        // this.loadData(1)
      } else {
        this.$message.error('复制失败')
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.ant-table {
  width: fit-content;
}

.selectBtn {
  border: 1px solid #dedede;
  padding: 5px 10px;
  border-radius: 5px;
  display: block;
}
</style>